/**
 * @copyright Copyright 2024-2024 Epic Systems Corporation
 * @file Base download component
 * @module Epic.AppOrchard.Download
 */

import { ITopLevelComponentProps } from "ao/types";
import { getIntFromSearchParam } from "ao/utils/helpers";
import React, { FunctionComponent, memo } from "react";
import { useSearchParams } from "react-router-dom";
import DownloadApp from "./DownloadApp";
import DownloadSearch from "./DownloadSearch";

const Download: FunctionComponent<ITopLevelComponentProps> = memo((props) => {
	const { userSecurity } = props;

	const [searchParams] = useSearchParams();
	const id = getIntFromSearchParam(searchParams, "id");

	return id > 0 ? (
		<DownloadApp userSecurity={userSecurity} />
	) : (
		<DownloadSearch userSecurity={userSecurity} />
	);
});

export default Download;
